import bg from "assets/images/bg/bg-sou-coop.jpg";
import section from "assets/images/section/sou-coop.svg";
import Eliza from "components/ui/Eliza";
import logo from "assets/images/logo-sou-coop.svg";
import DialogBubble from "components/dialog/dialog-bubble";

export default function SouCoopInfo() {
	return (
		<div
			className="bg-black absolute top-0 left-0 w-full h-full"
			style={{
				backgroundImage: `url(${bg})`,
			}}
		>
			<div className="absolute top-32 right-20">
				<img
					src={logo}
					alt="Selo"
					className="w-[400px] mx-auto mt-8 border-8 border-white rounded-full shadow-glow-blue"
				/>
			</div>

			<Eliza
				name="home"
				className="absolute left-[-50px] -bottom-[50px] w-[850px] -scale-x-[100%]"
			/>

			<div className="absolute w-[874px] left-[400px] top-[300px] animate-in slide-in-from-left-10">
				<DialogBubble model="left">
					<p>
						O <b>Sou Coop</b> é a plataforma oficial do Sistema OCB que reúne
						informações das cooperativas brasileiras,
						<br /> permitindo atualização
						cadastral e acesso a serviços e programas do movimento.
					</p>
				</DialogBubble>
			</div>

			<img
				src={section}
				alt="Somos Coop"
				className="w-[40%] animate-in slide-in-from-right-5 absolute right-0 bottom-0 object-contain object-center"
			/>
		</div>
	);
}
